
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 28.8C8.944 28.8 3.2 23.056 3.2 16 3.2 8.944 8.944 3.2 16 3.2c7.056 0 12.8 5.744 12.8 12.8 0 7.056-5.744 12.8-12.8 12.8zM16 0C7.152 0 0 7.152 0 16c0 8.848 7.152 16 16 16 8.848 0 16-7.152 16-16 0-8.848-7.152-16-16-16zm4.144 9.6L16 13.744 11.856 9.6 9.6 11.856 13.744 16 9.6 20.144l2.256 2.256L16 18.256l4.144 4.144 2.256-2.256L18.256 16l4.144-4.144L20.144 9.6z","fill":"#D32F2F"}})])
          )
        }
      }
    